// extracted by mini-css-extract-plugin
export default {"layout":"PositionView_layout__O3tIw","card":"PositionView_card__DkD0d"};